import type { ReactNode } from "react";
import { Collapse } from "antd";

export default function ExplanationDropdown({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) {
  return (
    <Collapse
      className="insight-collapse rounded-[4px]"
      expandIconPlacement="end"
      items={[
        {
          key: "explanation",
          label: <span className="text-[#00000073]">{label}</span>,
          children,
        },
      ]}
    />
  );
}
